export default {
  isLoading: ({ isLoading }) => isLoading,
  invoices: ({ invoices }) => invoices,
  invoicesHistory: ({ invoicesHistory }) => invoicesHistory,
  stats: ({ stats }) => stats,
  totalARBalance: ({ totalARBalance }) => totalARBalance,
  totalDisputedARBalance: ({ totalDisputedARBalance }) => totalDisputedARBalance,
  defaultHeaders: () => [
    'workflowEnabled',
    'displayId',
    'customer.displayName',
    'status',
    'dueDate',
    'daysOverdue',
    'localBalance',
    'localTotalAmount',
  ],
  selected: ({ selected }) => selected,
};
